import { Injectable, inject } from '@angular/core';
import { ENV_CONFIG, EnvironmentConfig, Page, PageResponse, PageUtil } from '@libs/vc-core-lib';
import { IAdHocTaskCreateRequestCriteriaDTO } from '../dto/ad-hoc-task-create.criteria.dto';
import { map, Observable } from 'rxjs';
import { ITaskModel } from '../model/task.model';
import { IInstancePermissionsHolderModel } from '../model/instance-permissions-holder.model';
import { ITaskSearchDTO } from '../dto/task.search.dto';
import { ITaskStatusPatchRequestModel } from '../model/task-status-patch-request.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class AssessmentTaskService {
    private readonly _httpClient: HttpClient = inject(HttpClient);
    private readonly _environment: EnvironmentConfig = inject(ENV_CONFIG);
    private readonly _assessmentTaskPath = 'assessment/task';

    public getTaskById(assessmentId: number, id: number): Observable<ITaskModel> {
        return this._httpClient.get<ITaskModel>(
            `${this._environment.APP.VC_ASSESSMENT_BASE_URL}/assessment/${assessmentId}/task/${id}`
        );
    }

    public getTaskDetailById(assessmentId: number, taskId: number): Observable<ITaskModel> {
        return this._httpClient.get<ITaskModel>(
            `${this._environment.APP.VC_ASSESSMENT_BASE_URL}/assessment/${assessmentId}/task/${taskId}`
        );
    }

    public searchTasks(searchDTO: ITaskSearchDTO): Observable<Page<ITaskModel>> {
        return this._httpClient
            .post<
                PageResponse<ITaskModel>
            >(`${this._environment.APP.VC_ASSESSMENT_BASE_URL}/task/page-search`, searchDTO)
            .pipe(map((pageResponse: PageResponse<ITaskModel>) => PageUtil.convertToPage(pageResponse)));
    }

    public createNewAdhocTask(
        model: IAdHocTaskCreateRequestCriteriaDTO,
        assessmentId: number,
        taskId: number
    ): Observable<ITaskModel> {
        return this._httpClient.post<ITaskModel>(
            `${this._environment.APP.VC_ASSESSMENT_BASE_URL}/assessment/${assessmentId}/task/${taskId}/adhoc-task`,
            model
        );
    }

    public patchTaskStatus(
        assessmentId: number,
        taskId: number,
        taskStatusPatchRequestModel: ITaskStatusPatchRequestModel
    ): Observable<ITaskModel> {
        return this._httpClient.patch<ITaskModel>(
            `${this._environment.APP.VC_ASSESSMENT_BASE_URL}/assessment/${assessmentId}/task/${taskId}/status`,
            taskStatusPatchRequestModel
        );
    }

    public getTaskByIdWithPermissions(id: number, assessmentId: number): Observable<IInstancePermissionsHolderModel> {
        return this._httpClient.get<IInstancePermissionsHolderModel>(
            `${this._environment.APP.VC_ASSESSMENT_BASE_URL}/assessment/${assessmentId}/task/${id}/permissions`
        );
    }
}
